module.exports = __webpack_public_path__ + "img/IMG_2493_FoamcoreMatted.a751f160.jpg";